import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    logs: [],
    logFilters: null,
    logModelTypes: [
      {
        title: 'Сотрудник',
        id: 'App\\Models\\Employer',
      },
      {
        title: 'Услуга',
        id: 'App\\Models\\Service',
      },
      {
        title: 'Подразделение',
        id: 'App\\Models\\Unit',
      },
      {
        title: 'Должность',
        id: 'App\\Models\\WorkPosition',
      },
      {
        title: 'Цена услуги',
        id: 'App\\Models\\ServicePrice',
      },
      {
        title: 'Клиент',
        id: 'App\\Models\\User',
      },
      {
        title: 'Расписание',
        id: 'App\\Models\\EmployerSchedule',
      },
    ],
    logEvents: [
      {
        title: 'Редактирование',
        id: 'updated',
      },
      {
        title: 'Создание',
        id: 'created',
      },
      {
        title: 'Удаление',
        id: 'deleted',
      },
    ],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
